import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyeSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEyeSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M12.001 4C16.2401 4.00003 20.3391 6.61173 22.8887 11.541L23.127 12L22.8887 12.459C20.3391 17.3883 16.2401 19.9999 12.001 20C7.76182 20 3.66189 17.3883 1.1123 12.459L0.875 12L1.1123 11.541C3.66189 6.61168 7.76183 4.00003 12.001 4ZM10.5996 10.5996L8 11.5996V12.4004L10.5996 13.4004L11.5996 16H12.4004L13.4004 13.4004L16 12.4004V11.5996L13.4004 10.5996L12.4004 8H11.5996L10.5996 10.5996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyeSparkle;
